module.exports = __webpack_public_path__ + "static/swift-logo-5b16107d95dc2b90c3c994f8e5d071a6.png";